import React from 'react'
import Shimmer from 'Components/shimmer'

const MaleDailyArticleCardFiveShimmer = () => {
  return (
    <>
      <div className="article-style-five-shimmer">
        <div className="article-style-five-shimmer__image">
          <Shimmer width="120px" height="120px" />
        </div>
        <div className="article-style-five-shimmer__text">
          <Shimmer width="88px" height="12px" />
          <div className="article-style-five-shimmer__title">
            <Shimmer width="100%" height="12px" />
            <Shimmer width="100%" height="12px" />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .article-style-five-shimmer {
            display: grid;
            grid-template-columns: 120px 1fr;
            gap: 20px;
            text-decoration: none;
          }

          .article-style-five-shimmer__image {
            height: 120px;
            width: auto;
            aspect-ratio: 1;
          }

          .article-style-five-shimmer__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
            justify-content: center;
          }
        `}
      </style>
    </>
  )
}

export default MaleDailyArticleCardFiveShimmer
